import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CampaignIcon} from './svg/campaign-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EnvelopeIcon} from './svg/envelope-icon';

type Props = {
    messageCount: number;
    size: number;
};

EmailSequenceIcon.prototype.defaultProps = {
    size: 15,
};

export function EmailSequenceIcon(props: Props) {
    const {size, messageCount} = props;

    return messageCount > 1 ? (
        <CampaignIcon size={size} wrapWithDiv={false} />
    ) : (
        <EnvelopeIcon size={size} wrapWithDiv={false} />
    );
}
